import { render, staticRenderFns } from "./CandidateItemReservation.vue?vue&type=template&id=96b58bfa&scoped=true&lang=pug&"
import script from "./CandidateItemReservation.vue?vue&type=script&lang=js&"
export * from "./CandidateItemReservation.vue?vue&type=script&lang=js&"
import style0 from "./CandidateItemReservation.vue?vue&type=style&index=0&id=96b58bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b58bfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VIcon,VSelect,VTextField})
